import attendanceReportAPI from '@/api/attendance-report/attendance-report.js';

const state = () => ({
  reports: [],
  reportDetail: null,
  pagination: {
    total: 0,
    page: 1,
    limit: 10,
    totalPage: 0
  },
  loading: false,
  error: null
});

const mutations = {
  SET_REPORTS(state, reports) {
    state.reports = reports;
  },
  SET_REPORT_DETAIL(state, reportDetail) {
    state.reportDetail = reportDetail;
  },
  SET_PAGINATION(state, pagination) {
    state.pagination = {
      total: pagination.total || 0,
      page: pagination.page || 1,
      limit: pagination.limit || 10,
      totalPage: pagination.totalPage || 0
    };
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  CLEAR_ERROR(state) {
    state.error = null;
  }
};

const actions = {
  async fetchReports({ commit }, params) {
    commit('SET_LOADING', true);
    commit('CLEAR_ERROR');
    
    try {
      const response = await attendanceReportAPI.getAttendanceReports(params);
      
      if (response.data && response.data.data) {
        // Set reports from data.data
        commit('SET_REPORTS', response.data.data.data || []);
        
        // Set pagination from data object
        if (response.data.data) {
          commit('SET_PAGINATION', {
            total: response.data.data.total || 0,
            page: response.data.data.page || 1,
            limit: response.data.data.limit || 10,
            totalPage: response.data.data.totalPage || 0
          });
        }
      }
      
      return response.data;
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to fetch attendance reports');
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async fetchReportDetail({ commit }, id) {
    commit('SET_LOADING', true);
    commit('CLEAR_ERROR');
    
    try {
      const response = await attendanceReportAPI.getAttendanceReportDetail(id);
      
      if (response.data) {
        commit('SET_REPORT_DETAIL', response.data.data);
      }
      
      return response.data;
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to fetch attendance report detail');
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async fetchSchedules({ commit }, id) {
    commit('SET_LOADING', true);
    commit('CLEAR_ERROR');
    
    try {
      const response = await attendanceReportAPI.getAttendanceSchedules(id);
      
      return response.data;
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to fetch attendance schedules');
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async fetchScheduleEmployees({ commit }, { id, params }) {
    commit('SET_LOADING', true);
    commit('CLEAR_ERROR');
    
    try {
      const response = await attendanceReportAPI.getScheduleEmployees(id, params);
      
      return response.data;
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to fetch schedule employees');
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async downloadReport({ commit }, trainingEventId) {
    try {
      const response = await attendanceReportAPI.downloadReport(trainingEventId);
      return response;
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to download report');
      throw error;
    }
  },

  async downloadScheduleReport({ commit }, scheduleId) {
    try {
      const response = await attendanceReportAPI.downloadScheduleReport(scheduleId);
      return response;
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to download schedule report');
      throw error;
    }
  },

  async downloadAllReports({ commit }, params) {
    try {
      const response = await attendanceReportAPI.downloadAllReports(params);
      return response;
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to download all reports');
      throw error;
    }
  },

  clearError({ commit }) {
    commit('CLEAR_ERROR');
  }
};

const getters = {
  reports: (state) => state.reports,
  reportDetail: (state) => state.reportDetail,
  pagination: (state) => state.pagination,
  loading: (state) => state.loading,
  error: (state) => state.error
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
